import status_account_on_validation from './status-account-on-validation.json';
import signature_requested from './signature-requested.json';
import request_send from './request_send.json';

export default {
  ...status_account_on_validation,
  ...signature_requested,
  ...request_send,
};
